
import { defineComponent } from 'vue';
import { OioInput } from '@kunlun/vue-ui-antd';

export default defineComponent({
  name: 'EnterToTrigger',
  components: {
    OioInput
  },
  props: ['onEnter', 'placeholder', 'value', 'change']
});
